export const LoadinAction = (isOpen) => ({
  type: 'LOADING',
  payload: isOpen
})

export const SpinnerAction = (isOpen) => ({
  type: 'SPINNER',
  payload: isOpen
})

export const LoadinProgress = (progress) => ({
  type: 'LOADING_PROGRESS',
  payload: progress
})
